import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import axiosClient from "../../models/axiosClient";
import Paginate from "../../components/paginate/Paginate";
import { toast } from "react-toastify";
import ThemeBreadcrumb from "../../components/themes/ThemeBreadcrumb";

function AgentDepositPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [amount, setAmount] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const loadUsers = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axiosClient.get(`/api/agent/users?page=${page}&search=${searchQuery}`);
      if (res.success) {
        setUsers(res.data.data || []);
        setCurrentPage(res.data.current_page || 1);
        setTotalPages(res.data.last_page || 1);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    loadUsers(1);
  };

  const handleDeposit = async () => {
    if (!selectedUser || !amount || amount <= 0) {
      toast.error("Vui lòng nhập số tiền hợp lệ");
      return;
    }
    try {
      const res = await axiosClient.post("/api/agent/deposit-to-user", {
        user_id: selectedUser.id,
        amount: parseInt(amount),
      });
      if (res.success) {
        toast.success("Nạp tiền thành công");
        setShowModal(false);
        setAmount("");
        setSelectedUser(null);
        loadUsers(currentPage);
      } else {
        toast.error(res.message || "Có lỗi xảy ra");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Có lỗi xảy ra");
    }
  };

  const formatMoney = (amount) => {
    return new Intl.NumberFormat("vi-VN").format(amount) + " đ";
  };

  return (
    <div className="container-fluid">
      <ThemeBreadcrumb title="Nạp tiền cho User" />
      
      <div className="card">
        <div className="card-header">
          <Form onSubmit={handleSearch} className="d-flex gap-2">
            <Form.Control
              type="text"
              placeholder="Tìm kiếm user..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ maxWidth: "300px" }}
            />
            <Button type="submit" variant="primary">Tìm</Button>
          </Form>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="text-center py-4">Đang tải...</div>
          ) : (
            <Table responsive striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Tên</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Số dư</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, index) => (
                  <tr key={user.id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.user_name}</td>
                    <td>{user.email}</td>
                    <td>{formatMoney(user.account_balance || 0)}</td>
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => {
                          setSelectedUser(user);
                          setShowModal(true);
                        }}
                      >
                        Nạp tiền
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          
          <Paginate
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={(page) => loadUsers(page)}
          />
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Nạp tiền cho {selectedUser?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Số tiền (VNĐ)</Form.Label>
            <Form.Control
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Nhập số tiền"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Hủy
          </Button>
          <Button variant="success" onClick={handleDeposit}>
            Xác nhận
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AgentDepositPage;
